import { Link } from 'react-router-dom';
import { SiteMeta } from '@/components/site/SiteMeta';

/**
 * Página 404. O build grava esta página em `404.html`, e o nginx devolve com
 * status 404 de verdade para caminho que não existe. Antes, qualquer endereço
 * inventado respondia 200 com a home, e o Google gastava rastreamento com isso.
 */
export function NotFoundPage() {
  return (
    <>
      <SiteMeta title="Página não encontrada | Operax" description="Esta página não existe ou mudou de endereço." path="/404" noindex />
      <section className="page-hero">
        <div className="hero-grid-bg" />
        <div className="shell page-hero-in rev">
          <div className="eyebrow">Erro 404</div>
          <h1>Essa página não existe.</h1>
          <p className="lead">O endereço pode ter mudado. Os caminhos abaixo levam ao que a maioria procura.</p>
          <div className="hero-cta" style={{ marginTop: 28 }}>
            <Link className="btn btn-primary" to="/">
              Ir para o início
            </Link>
            <Link className="btn btn-ghost" to="/apps">
              Ver os apps
            </Link>
            <Link className="btn btn-ghost" to="/precos">
              Ver preços
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
